// The styles every mark comes in, in the order they are offered.

export const markStyles = ['flag', 'seal', 'logo', 'simple', 'pixel', 'motion'] as const
export type MarkStyle = (typeof markStyles)[number]

export const markStyleInfo: Record<MarkStyle, { name: string; note: string; use: string }> = {
  flag: {
    name: 'Flag',
    note: 'The national flag, or the agency flag: its seal on a field of its color.',
    use: 'Default. Public services and the agency home page.',
  },
  seal: {
    name: 'Seal',
    note: 'The Great Seal of the United States, or the agency seal.',
    use: 'Formal pages, documents and the identifier.',
  },
  logo: {
    name: 'Logo',
    note: 'For the nation, the Great Seal’s shield with USA in its chief; for an agency, its logo where it differs from the seal, such as the Pentagon symbol.',
    use: 'Headers and product sites that follow the agency brand guide.',
  },
  simple: {
    name: 'Simple',
    note: 'A flat emblem from a motif in the seal; a simple striped flag for the nation.',
    use: 'Favicons, small sizes and quiet headers.',
  },
  pixel: {
    name: 'Pixel',
    note: 'The same motif drawn on a 16 by 16 grid.',
    use: 'Developer tools, launches and playful campaigns.',
  },
  motion: {
    name: 'Motion',
    note: 'The flag waving, for the nation or the agency.',
    use: 'Heroes and moments, never beside reading text.',
  },
}

/** The flag drawings; flag, seal and logo all show the official flag. */
export type FlagVariant = 'official' | 'simple' | 'pixel' | 'motion'

export function flagVariant(variant: FlagVariant | MarkStyle): FlagVariant {
  return variant === 'flag' || variant === 'seal' || variant === 'logo' ? 'official' : variant
}
